"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockPastTournaments = {
    success: true,
    tournaments: [
        {
            uuid: '0f4460a7-906d-4dd7-a221-f365e4092c53',
            name: 'Test2',
            dateTime: '2024-02-06T08:00:00.000Z',
            frameworks: ['java', 'python'],
            numberOfRounds: 2,
            numParticipatedUsers: 1,
            didManage: true,
            didParticipate: false,
            userScore: 0,
        },
        {
            uuid: '68cb2d2a-c309-4a5d-8b8e-32379034f3a1',
            name: 'Test1',
            dateTime: '2024-01-29T08:00:00.000Z',
            frameworks: ['java', 'python'],
            numberOfRounds: 2,
            numParticipatedUsers: 0,
            didManage: true,
            didParticipate: false,
            userScore: 0,
        },
    ],
};
exports.default = mockPastTournaments;
